import React from "react";
import { useMediaQuery } from "@mantine/hooks";
import { TimeZoneDesktop } from "./TimeZoneDesktop";
import { TimeZoneMobile } from "./TimeZoneMobile";

export default function TimeZoneSelect() {
  const isMobile = useMediaQuery("(max-width: 768px)");
  return isMobile ? <TimeZoneMobile /> : <TimeZoneDesktop />;
}
